import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectorComponent } from './connector.component';
import { SubComponentComponent } from './sub-component/sub-component.component';
import { PlanificationDialogComponent } from './planification-dialog/planification-dialog.component';
import { LaunchDialogComponent } from './launch-dialog/launch-dialog.component';
import { NbSelectModule, NbIconModule, NbCardModule, NbInputModule, NbCheckboxModule, NbTagModule, NbButtonModule} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogComponent } from '../log/log.component';
import { LogModule } from '../log/log.module';
import { FileUploadModalComponent } from '../file-upload-modal/file-upload-modal.component';



@NgModule({
  declarations: [
    ConnectorComponent,
    SubComponentComponent,
    PlanificationDialogComponent,
    LaunchDialogComponent,
    FileUploadModalComponent
  ],
  imports: [
    CommonModule,
    NbSelectModule,
    NbIconModule,
    NbCardModule,
    NbButtonModule,
    ReactiveFormsModule,
    FormsModule,
    LogModule,
    NbInputModule,
    NbCheckboxModule,
    NbTagModule,
  ],
})
export class ConnectorModule { }
